import { Card, Descriptions } from 'antd'
import { Customer } from 'types'

interface CustomerDetailsProps {
  customer?: Customer | null
}

const CustomerDetails = ({ customer }: CustomerDetailsProps) => {
  return (
    <Card title="Customer Details" className="flex-grow-1">
      {customer ? (
        <Descriptions layout="horizontal" size="small" column={1}>
          <Descriptions.Item label="Name">
            {customer.first_name} {customer.last_name}
          </Descriptions.Item>
          <Descriptions.Item label="Address">{customer.address}</Descriptions.Item>
          <Descriptions.Item label="City">
            {customer.city} {customer.zip_code}
          </Descriptions.Item>
          <Descriptions.Item label="Country">{customer.country}</Descriptions.Item>
        </Descriptions>
      ) : (
        <div>No customer details available</div>
      )}
    </Card>
  )
}

export default CustomerDetails
